module.exports = {"headerTitle":{"fontSize":"16","bold":"true"},"cardTitle":{"fontSize":"14","bold":"true"},"textCell":{"fontSize":"10"},"numericCell":{"alignment":"right","fontSize":"10"},"headerCell":{"bold":"true","fontSize":"12"},"pageNumberFooter":{"fontSize":"10"}}


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pdf/pdf-doc-styles.json
// module id = sUjQ
// module chunks = 0